import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, rem } from '@bonusly/design-system';

import { Announcement } from '../../types/announcements';
import { AnnouncementsCarouselContent } from './announcements-carousel-content';

interface AnnouncementsCarouselModalProps {
	announcements: Announcement[];
	isOpen: boolean;
	onClose: () => void;
	selectedAnnouncementId?: string;
}

export const AnnouncementsCarouselModal: FC<AnnouncementsCarouselModalProps> = ({ announcements, isOpen, onClose, selectedAnnouncementId }) => {
	const { t } = useTranslation('announcements');

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="2xl" trapFocus={false}>
			<ModalOverlay />
			<ModalContent bg="bg.canvas">
				<ModalHeader borderBottom="none" px={rem(20)} pt={rem(16)} pb={rem(4)}>
					{t('carousel.header')}
				</ModalHeader>
				<ModalCloseButton size="md" borderRadius="full" />
				<ModalBody px={rem(20)} pb={rem(16)}>
					<AnnouncementsCarouselContent announcements={announcements} selectedAnnouncementId={selectedAnnouncementId} />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
